import { render } from "./PropertyChange.vue?vue&type=template&id=0d0b2696"
import script from "./PropertyChange.vue?vue&type=script&lang=js"
export * from "./PropertyChange.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__